import { useContext } from "react"
import { EdicaoClienteContext } from "./EdicaoClienteContext"

export function useEdicaoClienteContext() {
    return useContext(EdicaoClienteContext)
}
